import React from "react";
import Helmet from 'react-helmet';
import headersList from 'Constants/headersList';
import { withRouter } from "react-router-dom";
import Grid from "@material-ui/core/Grid";
import ToggleButton from '@material-ui/lab/ToggleButton';
import ToggleButtonGroup from '@material-ui/lab/ToggleButtonGroup';
import './Employee.scss';
import ChecklistCard from "./ChecklistCard";
import Expansion from './ExpansionComponent/Expansion';
import { instance } from '../../../../../../Actions/AxiosInstance';
import InputAdornment from "@material-ui/core/InputAdornment";
import { RightDrawer } from "../../../../../../Actions/commonAction";
import { withSnackbar } from "notistack";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import withStyles from "@material-ui/core/styles/withStyles";
import { bindActionCreators } from "redux";
import { refreshProfileInfo } from "../../../../../../Actions/commonAction";
import DrawerHeader from "Component/Headers/drawerHeader";
import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Drawer from "@material-ui/core/Drawer";
import Divider from "@material-ui/core/Divider";
import Paper from "@material-ui/core/Paper";
import CheckImg from "../../../../../../Assets/Images/check.png";
import classNames from "classnames";
import Tooltip from "@material-ui/core/Tooltip";
import {
  getFormattedImageLink,
} from "../../../../../../Utils";
import ProfilePicture from "../../../../../../Component/Thumbnail/ProfilePicture";
import designationIcon from "../../../../../../Assets/newicons/attribute/designation/outline/designation-outline-16px.svg";
class ChecklistView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      alignment: 'left',
      showComponent: false,
      postData: null,
      selectedChecklist: { checklistid: null },

    };
    this.onChecklistClick = this.onChecklistClick.bind(this);
    this.getCheckListDetails = this.getCheckListDetails.bind(this);
    this.getChecklistStatus = this.getChecklistStatus.bind(this);
    

  }


  reloadChecklistOnDone = async (checklist) => {
    try {
      await this.props.onChangetoggle(this.state.alignment === 'left' ? false : true);
      await this.getCheckListDetails(checklist);
    } catch (error) {
      console.error(error);
    }
  };

  getCheckListDetails = async (checklist) => {
    try {
      const checklistDetails = await instance.get(`checklist/empchecklist/${this.props.isShared}/${checklist.empchecklistid}`);
      this.setState({
        showComponent: true,
        postData: checklistDetails.data.result[0].checklistactivity,
        selectedChecklist: checklist,
        checklistid:(checklist)?checklist.checklistid:null,
      });
    } catch (error) {
      console.error(error);
    }
  };

  getChecklistStatus(checklistid) {
    // try {
    //   const checkliststatus = instance.get(`checklist/checklistemployee/${this.state.checklistid}`);
    //   //this.HelperSliderFlag(true, checkliststatus.data.result)
    //    this.setState({
    //       logs: checkliststatus.data.result,
    //       drawerToggle: true,
    //       drawerName:"Activity employee status",
    //     });
    // } catch (error) {
    //   console.error(error);
    // }
    
    instance.get(
        `checklist/checklistemployee/${this.state.checklistid}`)
      .then((res) => {
       //this.HelperSliderFlag(true, res.data.result)
        this.setState({
          logs: res.data.result,
          drawerToggle: true,
          drawerName:"Activity status",
        });
        // console.log('logs: ', this.state.logs);
      });
  }

  async onChecklistClick(checklist) {
    console.log("checklist",checklist.checklistid);
    try {
      await this.getCheckListDetails(checklist);
    } catch (error) {
      console.error(error);
    }
  }

  getActivityStartText = (purpose) => {
    switch (purpose) {
      case 1:
        return "Date of joining";
      case 2:
        return "Date of resignation approved";
      case 3:
        return "Date of promotion";
      default:
        return "Date of probation confirmation";
    }
  };

  handleAlignment = async (event, alignment) => {
    if (alignment === 'left') {
      await this.props.onChangetoggle(false);
    } else {
      await this.props.onChangetoggle(true);
    }
    this.setState({ alignment, showComponent: false });
  };

  componentDidMount() {

  }

  HelperSliderFlag(flag, text) {
    // this.setState({ HelperSlider: flag })
    let OpenFlag = "";
    if (flag == true) {
      OpenFlag = true;
      this.setState({ OpenFlag });
    } else {
      OpenFlag = false;
      this.setState({ OpenFlag });
    }
    if (text == "Profilemanager") {
      this.props.RightDrawer({
        drawerdata: text,
        open: "right",
        side: flag,
        empid: this.state.employeeid,
      });
    } else {
      this.props.RightDrawer({ drawerdata: text, open: "right", side: flag });
    }
  }


  render() {
    const { alignment, postData, selectedChecklist } = this.state;
    const { activeAssignlist, inactiveAssignlist, completedAssignlist, isShared } = this.props;

    return (
      <Grid container xs={12} className="checklistViewContainer" >
        <Helmet>
          <title>{headersList.CheckList.header}</title>
        </Helmet>
        <Grid items xs={6} sm={6} lg={4} className="leftSection">
          <Grid item>
            <ToggleButtonGroup value={alignment} exclusive onChange={this.handleAlignment} classes={{ root: 'ToggleButtonGroup' }} >
              <ToggleButton value="left" classes={{ root: 'ToggleButton', selected: 'selected', label: 'toggletext' }} >
                My checklists
              </ToggleButton>
              <ToggleButton value="right" classes={{ root: 'ToggleButton', selected: 'selected', label: 'toggletext' }}>
                Shared checklists
              </ToggleButton>
            </ToggleButtonGroup>
          </Grid>
          <Grid container className="activityDivider">
            <hr className="dashedDivider" />
            <p className="dividerText" ><span>Ongoing</span></p>
            <hr className="dashedDivider" />
          </Grid>
          <Grid item >
            {!activeAssignlist.length
              ? <div className='NoChecklistCard' >
                No active checklist
              </div>
              : activeAssignlist.map((checklist) => <ChecklistCard key={checklist.empchecklistid} selected={checklist.empchecklistid === selectedChecklist.empchecklistid} onChecklistClick={this.onChecklistClick} checklist={checklist} />)
            }
          </Grid>
          <Grid container className="activityDivider">
            <hr className="dashedDivider" />
            <p className="dividerText" ><span className="LineDrawn">completed</span></p>
            <hr className="dashedDivider" />
          </Grid>
          <Grid item >
            {!completedAssignlist.length
              ? <div className='NoChecklistCard'>
                No completed checklist
              </div>
              : completedAssignlist.map((checklist) => <ChecklistCard key={checklist.empchecklistid} selected={checklist.empchecklistid === selectedChecklist.empchecklistid} onChecklistClick={this.onChecklistClick} checklist={checklist} />)
            }
          </Grid>
          <Grid container className="activityDivider">
            <hr className="dashedDivider" />
            <p className="dividerText" ><span className="LineDrawn">inactive</span></p>
            <hr className="dashedDivider" />
          </Grid>
          <Grid item >
            {
              !inactiveAssignlist.length
                ? <div className='NoChecklistCard'>
                  No in-active checklist
              </div>
                : inactiveAssignlist.map((checklist) => <ChecklistCard key={checklist.empchecklistid} selected={checklist.empchecklistid === selectedChecklist.empchecklistid} onChecklistClick={this.onChecklistClick} checklist={checklist} />)
            }
          </Grid>
        </Grid>
        <Grid items className="rightSection">
          <Grid container>
            <Grid item xs={1}>
            </Grid>
            <Grid item xs={11}>
              <Grid container className="activityDividing">
                <hr className="dashedDivider" />
                <p className="dividerText" ><span className="LineDrawn">Activities start on ({this.getActivityStartText(selectedChecklist.purpose)})</span></p>
                <hr className="dashedDivider" />

              </Grid>
            </Grid>
          </Grid>
          <Grid container>

          {this.state.showComponent ? 
            <Grid item xs={12} md={12} sm={12}>
            <span
               // className="rounded-rectangle-div"
                style={{
                  padding: "8px 0px",
                  margin: "16px 0px",
                  display: "flex",
                  //height: 25,
                  alignItems: "center",
                  cursor: "pointer",
                  float:"right",
                  textDecoration:"underline",
                  display:"inline-block",
                  
                }}
                onClick={this.getChecklistStatus.bind(
                  this.state.checklistid
                )}
                //onClick={() => this.openOptions(true)}
              >
                <p className="normal-dark-secondary">
                 
                <InputAdornment position="end">
                Activity status
                </InputAdornment>
                </p>
            </span>
            </Grid>  : null}
            
            {this.state.showComponent ? <Expansion postData={postData} isShared={isShared} selectedChecklist={selectedChecklist} reloadChecklistOnDone={this.reloadChecklistOnDone} /> : null}
          </Grid>
        </Grid>
        <Drawer
              anchor="right"
              open={this.state.drawerToggle}
              onClose={() => this.setState({ drawerToggle: false })}
              classes={{
                paper: "width30",
              }}
            >
              <div
                className="margin-top-24 margin-left-20 margin-right-20 thin-scroll"
                style={{ overflowY: "auto" }}
              >
                <DrawerHeader
                  header={this.state.drawerName}
                  closeDrawer={() => this.setState({ drawerToggle: false })}
                />
                <div>
                  {this.state.logs && this.state.logs.length == 0 ? (
                    <CallOutNew
                      classnames="bg-light-blue width100"
                      header="No logs available"
                      // emoji="🔍"
                      textcolor="#1e8ced"
                    />
                  ) : (
                    <>
                      {this.state.logs &&
                        this.state.logs.map((x) => (
                          <div>
                            <div style={{ marginBottom: 10 }}></div>
                            <Paper>
                              <ExpansionPanel
                                style={{
                                  boxShadow: "0px 0px 0px",
                                  margin: 0,
                                  "&$expanded": {
                                    margin: 0,
                                    minHeight: 40,
                                    marginBottom: 0,
                                  },
                                }}
                                square
                                key="key"
                                className="expansion-panel-rejected-expense"
                              >
                                <ExpansionPanelSummary
                                  style={{
                                    height: "100%",
                                    minHeight: 40,
                                  }}
                                  expandIcon={<ExpandMoreIcon />}
                                >
                                  <div>{x.title}</div>
                                </ExpansionPanelSummary>
                                {/* <ExpansionPanelDetails> */}
                                  <div style={{ width: "100%" }}>
                                    {x.checklistemployee
                                      ? x.checklistemployee.map((y) => (
                                        <div
                                        className="display-flex"
                                        style={{
                                          //borderBottom: "1px dashed #979797",
                                          padding: "16px 16px",
                                        }}
                                      >
                                        <ProfilePicture
                                          height={56}
                                          src={getFormattedImageLink(y.imagepath)}
                                          classname="margin-right-8"
                                        />
              
                                        <div>
                                          <p className="small-dark-secondary t-bold">
                                            {y.fullname}  {" "} {y.employeecode ? "[" + y.employeecode + "]": ""}
                                          </p>
                                          {y.designationname && (
                                            <div>
                                              <span>
                                                <img
                                                  src={designationIcon}
                                                  style={{ verticalAlign: "middle" }}
                                                ></img>
                                              </span>
                                              <span className="small-dark-secondary">
                                                {" "}
                                                {y.designationname}{" "}
                                              </span>
                                            </div>
                                          )}
                                           <p className="small-dark-secondary t-bold" 
                                          // style={{color : y.isdone ? "#00FF00" : "#FF0000" }}
                                           >
                                            { y.isdone ? "Done" : "Not done" }
                                          </p>
              
                                          {/* <p className=" margin-top-4 small-dark-secondary">
                                      Salary:{" "}
                                      {100000}
                                    </p> */}
                                        </div>
                                      </div>

                    // <Grid
                    //   item
                    //   xs={12}
                    //   md={3}
                    //   sm={4}
                    //   className="dir-emp-details-left"
                    //   style={{ height: "100%" }}
                    // >
                    //   <div className="position-rel">
                    //     <div
                    //       // onClick={this.GetSelectedProfiles.bind(this, data)}
                    //       className={classNames("dir-emp-img")}
                    //       style={{ paddingTop: 8 }}
                    //     >
                    //       <div
                    //         //onClick={this.GetSelectedProfiles.bind(this, data)}
                    //         className={classNames("cursour-pointer")}
                    //         style={{ width: 64 }}
                    //       >
                    //         {y.imagepath ? (
                    //           <img
                    //             className="dir-profile-img"
                    //             src={getFormattedImageLink(y.imagepath)}
                    //             height="64"
                    //           />
                    //         ) : (
                    //           <img
                    //             className="dir-profile-img"
                    //             src={CheckImg}
                    //             height="64"
                    //           />
                    //         )}
                    //       </div>
                    //     </div>
                    //     <div className="dir-emp-info2">
                    //       <span
                    //         className={classNames(
                    //           "cursour-pointer",
                    //           "no-padding",
                    //           "name-required-width",
                    //         )}
                    //        // onClick={this.RouteToProfile.bind(
                    //         //   this,
                    //         //   data.employeeid,
                    //         // )}
                    //         style={{
                    //           display: "block",
                    //           fontSize: 14,
                    //           marginTop: 14,
                    //           width: "100%",
                    //         }}
                    //       >
                    //         {y.fullname} {y.employeecode ? `[`y.employeecode `]`: ""}
                    //       </span>
                    //       <If condition={y.employeecode}>
                    //         <span
                    //           style={{
                    //             display: "block",
                    //             marginTop: 16,
                    //             overflow: "hidden",
                    //             textOverflow: "ellipsis",
                    //             whiteSpace: "nowrap",
                    //             fontSize: 14,
                    //           }}
                    //         >
                    //           <Tooltip
                    //             PopperProps={{
                    //               disablePortal: true,
                    //             }}
                    //             title={y.employeecode}
                    //             placement="top"
                    //           >
                    //             <span
                    //               className="ellipsis"
                    //               style={{
                    //                 width: 120,
                    //                 cursor: "default",
                    //                 fontSize: 14,
                    //               }}
                    //             >
                    //               {/* {data.designationname}  */}
                    //               {y.employeecode}
                    //             </span>
                    //           </Tooltip>
                    //         </span>
                    //       </If>
                    //     </div>
                    //   </div>
                    // </Grid>
                                          // <div
                                          //   style={{
                                          //     display: "flex",
                                          //     justifyContent: "start",
                                          //     flexDirection: "column",
                                          //   }}
                                          // >
                                          //   {y.salarycomponentname && (
                                          //     <div
                                          //       style={{
                                          //         display: "flex",
                                          //         flexDirection: "row",
                                          //       }}
                                          //     >
                                          //       <p className="normal-dark">
                                          //         Component name:
                                          //       </p>
                                          //       <p style={{ flex: 1 }}></p>
                                          //       <p
                                          //         style={{ float: "left" }}
                                          //         className="normal-dark"
                                          //       >
                                          //         {y.fullname}
                                          //       </p>
                                          //       {/* <div>Component name: </div><div style={{ flex: 1 }}></div><div>{getFormattedDate(y.date)}</div> */}
                                          //     </div>
                                          //   )}
                                          //   <div
                                          //     style={{
                                          //       display: "flex",
                                          //       flexDirection: "row",
                                          //     }}
                                          //   >
                                          //     <p className="normal-dark">
                                          //       Date:{" "}
                                          //     </p>
                                          //     <p style={{ flex: 1 }}></p>
                                          //     <p
                                          //       style={{ float: "left" }}
                                          //       className="normal-dark"
                                          //     >
                                          //       {y.designationname}
                                          //     </p>
                                          //   </div>
                                          //   <div style={{ display: "flex" }}>
                                          //     <p className="normal-dark">
                                          //       Amount:
                                          //     </p>
                                          //     <p style={{ flex: 1 }}></p>
                                          //     <p
                                          //       style={{ float: "left" }}
                                          //       className="normal-dark"
                                          //     >
                                          //       {y.employeecode}
                                          //     </p>
                                          //   </div>
                                          //   {/* {this.state.decSubValue == 2 && (
                                          //     <div
                                          //       style={{
                                          //         display: "flex",
                                          //         flexDirection: "row",
                                          //       }}
                                          //     >
                                          //       <p className="normal-dark">
                                          //         Attachment:
                                          //       </p>
                                          //       <p style={{ flex: 1 }}></p>
                                          //       <p className="normal-dark">
                                          //         {y.datapath
                                          //           ? y.datapath.map((z) => (
                                          //               // <div
                                          //               //   key="img"
                                          //               //   className="add-attachment"
                                          //               //   style={{ marginRight: 16, height: 50 }}
                                          //               // >
                                          //               //   <img
                                          //               //     src={getFormattedImageLink(z.submission)}
                                          //               //     className="expense-attachment-img"
                                          //               //   />
                                          //               // </div>
                                          //               <Thumbnail
                                          //                 canDelete={false}
                                          //                 key="i"
                                          //                 doc={{
                                          //                   url: z.submissionpath,
                                          //                 }}
                                          //               />
                                          //             ))
                                          //           : "No-Attachment"}
                                          //       </p>
                                          //     </div>
                                          //   )} */}
                                          //   <Divider />
                                          // </div>
                                        ))
                                      : "No logs to display"}
                                  </div>
                                {/* </ExpansionPanelDetails> */}
                              </ExpansionPanel>
                            </Paper>
                          </div>
                        ))}
                    </>
                  )}
                </div>
              </div>
        </Drawer>

      </Grid >
  
    );
  }
}



const mapStateToProps = (state) => ({
  refreshProfileInfoReducer: state.refreshProfileInfoReducer,
  SubscriptionData: state.SubscriptionInfo.SubscriptionData,
  AuthenticationAction: state.AuthenticationAction,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      RightDrawer: (data) => RightDrawer(data),
      refreshProfileInfo: (data) => refreshProfileInfo(data),
    },
    dispatch,
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)((withSnackbar(ChecklistView)));

//export default withRouter(ChecklistView);
